import { ToastOptions } from "react-toastify";

export const version = import.meta.env.VITE_APP_VERSION ?? "2.3.2";
export let domain;

if (import.meta.env.VITE_API_URL) {
  domain = import.meta.env.VITE_API_URL;
} else if (import.meta.env.PROD) {
  domain = "https://app.riivet.com/app";
} else {
  domain = "https://app.riivet.com/app";
  // domain = "https://dbapp.riivet.com";
  // domain = `http://localhost:3003`;
}
// staging domain
// domain = "https://staging-app.riivet.com";

// export domain;
export const prodURL = "https://app.riivet.com/app";
export const stagingURL = "https://staging-app.riivet.com";

export const baseUrl = `${domain}/api/v1`;
export const authUrl = `${domain}/api/auth`;
export const analyticsUrl = `${domain}/api/analytics/v1`;
export const financialUrl = `${domain}/api/financial/v1`;
export const marketingUrl = `${domain}/api/marketing/v1`;
export const accountUrl = `${domain}/api/account/v1`;
export const adminUrl = `${domain}/api/admin`;

// Staging builds set VITE_TUS_ENDPOINT so uploads go to the staging tusd
// instead of prod, where the upload token would not exist (RM-3942).
export const tusEndpoint =
  import.meta.env.VITE_TUS_ENDPOINT ||
  (import.meta.env.PROD
    ? "https://video.riivet.com/tus/files"
    : "http://localhost:3005/files");

export const OWNER_ROLE = "manage";
export const ADMIN_ROLE = "admin";
export const GREY_TEXT = "#495057";
export const INFO_COLOR = "#4169E1";
export const ERROR_COLOR = "#ff0000";

// Brand / action-bar colors — mirror $brand, $secondary, $danger in
// src/assets/themes/default/_variables.scss (MUI has no global theme configured).
export const BRAND_PRIMARY = "#545cd8";
export const BRAND_PRIMARY_HOVER = "#434aad";
export const SECONDARY = "#6c757d";
export const SECONDARY_HOVER = "#4e555a";
export const DANGER = "#a6193d";

// MUI renders a size="small" Autocomplete 40px tall; Bootstrap .btn and
// .form-select are 38px. Match this to line a search row's controls up.
export const SEARCH_INPUT_HEIGHT = 40;

export const toastOptions: ToastOptions<unknown> = {
  position: "bottom-right",
  pauseOnHover: true,
  hideProgressBar: true,
  theme: "colored",
  draggable: false,
  closeOnClick: false,
};

export const actionableToastOptions: ToastOptions<unknown> = {
  ...toastOptions,
  autoClose: 10000,
};

export const DEFAULT_IMAGES = {
  SMALL: "https://riivet.s3.amazonaws.com/missing/account_picture_small.png",
  MEDIUM: "https://riivet.s3.amazonaws.com/missing/account_picture_medium.png"
}
